import { RequestModuleEnum } from 'shared/enums/request-module-enum'

export const digitalProductDependencies: RequestModuleEnum[] = [
  RequestModuleEnum.Community,
  RequestModuleEnum.Tags,
  RequestModuleEnum.MembershipCourse,
  RequestModuleEnum.MembershipCourseCurriculum,
  RequestModuleEnum.CourseBundle,
]
